import { DATA_BINDING, WIX_CODE } from '@wix/app-definition-ids'

export const GFPP_ACTION_IDS = {
  SETTINGS_ACTION: 'settings',
  MANAGE_CONTENT_ACTION: 'manage-content',
}
export const LOCALE_FOLDER = 'locale/data-binding'

export const STUDIO_LOCALES_FOLDER = 'locale/studio-inspector'

const CM_SERVER_URL = '/_api/cm-server'

export const CLOUD_DATA_URL = '/_api/cloud-data'

export const DB_PANEL_BASENAME = `${CM_SERVER_URL}/dbsm-editor-app`

export const APP_DEF_ID = DATA_BINDING

export const APP_NAME = 'dbsm-editor-app'

export const LOCALE_FALLBACK_URL = `https://static.parastorage.com/services/dbsm-editor-app/1.10725.0`

export const EXPERIMENTS_HOST = ''

export const EXPERIMENTS_SCOPE = WIX_CODE

export const DATA_CLIENT_EXPERIMENTS_SCOPE = 'wix-data-client'

export const AUTO_CMS_EDITOR_PANEL_BASENAME = `${CM_SERVER_URL}/auto-cms-v2`

export const FORMAT_TYPES = {
  DATETIME: 'datetime',
}
